export const KEY_TECH_ID = 'TECH-ID';
export const KEY_ORDER_ID = 'ORDER-ID';

// ajax call tags
export const TAG_CLOSE_ORDER = 'close-order';
export const TAG_ADDRESSABLE_HIT = 'addressable-hit';
export const TAG_REFRESH_HIT = 'refresh-hit';
export const TAG_FETCH_WORK_ORDER = 'fetch-work-order';
export const TAG_ADD_EQUIPMENT_OPTIONS = 'equipment-add-options';
export const TAG_ADD_JUST_ASK_ITEMS = 'just-ask-items-add';
export const TAG_UPDATE_JUST_ASK_ITEMS = 'just-ask-items-update';
export const TAG_ADD_CHARGE = 'charge-add';
export const TAG_UPDATE_CHARGE = 'charge-update';
export const TAG_REMOVE_CHARGE = 'charge-remove';
export const TAG_GET_TECH_INVENTORY = 'tech-inventory-get';
export const TAG_SET_TECH_STATUS = 'tech-status-set';
export const TAG_GET_TECH_STATUS = 'tech-status-get';

// page tags
export const TAG_INVENTORY_PAGE = 'inventory-page';
export const TAG_CLOSE_ORDER_PAGE = 'close-order-page';
export const TAG_MY_ROUTE_PAGE = 'my-route-page';
export const TAG_WORK_ORDER_DETAILS_PAGE = 'work-order-details-page';

export const MFACTION_SET_VARIABLE = 'setVariable';
export const MFACTION_TAG = 'tag';
export const MFACTION_NEW_PAGE_VIEW = 'newPageView';


// WEBPACK FOOTER //
// ./src/constants/mouseFlow.js